import { render, staticRenderFns } from "./ElementConfigurableScaleConfigTableColumn.vue?vue&type=template&id=8ef9a0b0"
import script from "./ElementConfigurableScaleConfigTableColumn.vue?vue&type=script&lang=js"
export * from "./ElementConfigurableScaleConfigTableColumn.vue?vue&type=script&lang=js"
import style0 from "./ElementConfigurableScaleConfigTableColumn.vue?vue&type=style&index=0&id=8ef9a0b0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports